import React from 'react'
import routes from '../config/settings/routes'
import ManagementSectionContainer from '../containers/ManagementMenu/ManagementMenu.container'
import NavbarContainer from '../containers/Navbar/Navbar.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import Heading from '../components/Layouts/Heading'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import ProtectBySession from '../components/Security/ProtectBySession'
import NotFoundPage from './NotFound'
import PredictionContent from '../containers/Predictions/Predictions.container'
import PredictionsTopbar from '../containers/Predictions/PredictionsTopbar.container'

/**
 * The Predictions' page.
 */
const PredictionsPage = () => {
  const title = 'Predicciones'

  return (
    <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)}>
      <ProtectByFeatures rule={features => features['com.cosmos/predictions']} fallback={() => <NotFoundPage />}>
        <BrandLayout
          navbar={<NavbarContainer />}
          header={<Heading title={title} topbar={PredictionsTopbar} />}
          sidebar={<ManagementSectionContainer current={routes.predictionsGraphs} />}
        >
          <PredictionContent />
        </BrandLayout>
      </ProtectByFeatures>
    </ProtectBySession>
  )
}

export default PredictionsPage
